import * as React from 'react'
import { Switch } from '@progress/kendo-react-inputs';
import * as BaseControls from './../common/BaseControls';
import { ISystemBase } from 'library/types/ISystemBase';
import { SystemBase } from '../../library/common/SystemBase';

interface ISystemSwitch {
    onLabel?: string,
    offLabel?: string,

}
export default class SystemSwitch extends SystemBase<ISystemSwitch>{
    static defaultProps = {
        ...SystemBase.defaultProps,
        onLabel: "YES",
        offLabel: "NO"
    }
    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <this.WrapperDiv>
            <Switch
                    defaultValue={this.props.defaultValue}
                    onLabel={this.props.onLabel ? this.props.onLabel : "YES"}
                    offLabel={this.props.offLabel ? this.props.offLabel : "NO"}
                    checked={this.props.value}
                    disabled={this.props.disabled}
                    name={this.props.name}
                    required={this.props.isRequired}
                    value={this.props.value}
                    onChange={this.handleChangeSwtich}
                    className={this.props.className}
                />
            </this.WrapperDiv>
        )
    }
}